export default __webpack_public_path__ + "static/portfolio_gallery_2-5af5bcc7be34cf3e06d83729a4d4f858.jpg";